import React from "react";
import Helmet from "react-helmet";
import Loadable from "react-loadable";

import { Page, PageContent } from "../components/Layout";
import { Header } from "../components/Header";
import { createLoadingComponent } from "../components/Loading";

import "./Try.css";

export const TryFormLoadable = Loadable({
  loader: () => import("./Try/TryForm").then(m => m.TryForm),
  loading: createLoadingComponent("Catalog Playground"),
  delay: 500
});

export const Try = () => (
  <Page>
    <Helmet title="Try Catalog" />
    <div className="tryHeader" data-path="/try">
      <div className="containerHeader">
        <Header pinned />
      </div>
    </div>
    <PageContent>
      <TryFormLoadable />
    </PageContent>
  </Page>
);



// WEBPACK FOOTER //
// ./src/pages/Try.js